import React from 'react';
import i18n from '../../../../i18n';
import { Grid, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Text, TextTypography } from 'components/Text/Text';
import { Resend } from './Resend';

import { SignupCodeForm } from '../../../forms/SignupCodeForm/SignupCodeForm';

import { ReactComponent as LogoVertical } from 'assets/logo-vertical.svg';

const useStyles = makeStyles(theme => ({
    container: {
        position: 'absolute',
        height: '100vh',
        width: '100vw',
        top: 0,
        right: 0,
        backgroundColor: 'white',
        zIndex: 100,
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        textAlign: 'center',
    },
    title: {
        marginTop: theme.spacing(18),
        marginBottom: theme.spacing(3),
    },
    code: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
    },
}));

export const CodeForm = () => {
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    return (
        <Grid
            container
            direction={'column'}
            justify={'space-between'}
            alignItems={'center'}
            className={classes.container}
        >
            <Grid>
                <Hidden xsDown>
                    <LogoVertical />
                </Hidden>
            </Grid>
            <Grid>
                <div className={classes.title}>
                    <Text typography={TextTypography.DISPLAY_STRONG}>{t('auth:resetPassword.code.title')}</Text>
                </div>
                <SignupCodeForm />
            </Grid>
            <Grid>
                <Resend />
            </Grid>
        </Grid>
    );
};
